import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { IConnectionStatusService, CHANNEL_CONNECTION_STATUS } from "../IConnectionStatusService";
import { ConnectionStatus } from "../model/ConnectionStatus";
import { Observable, ReplaySubject } from "rxjs";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

const ENCODABLE_TYPE_ERRORS: string = "com.bcdfx.broker.ErrorsImpl";

@Injectable()
export class ConnectionStatusReplicaService implements IConnectionStatusService {
  protected broker: ClientMessageBroker;
  protected connectionEventSubject: ReplaySubject<ConnectionStatus> =
    new ReplaySubject<ConnectionStatus>(1);

  constructor(protected factory: ClientMessageBrokerFactory) {
    this.initService();
  }

  protected initService(): void {
    this.broker = this.factory.createMessageBroker(CHANNEL_CONNECTION_STATUS, true, true);

    let refreshChannel = new MessageChannel();
    let clientRefreshPort: MessagePort = refreshChannel.port1;
    let serviceRefreshPort: MessagePort = refreshChannel.port2;

    let request = new UiArguments("initPort", [
      new FnTransferableArg(serviceRefreshPort, PRIMITIVE),
    ]);

    clientRefreshPort.addEventListener("message", (event) => {
      if (event && event.data && event.data.connectionStatus >= 0) {
        this.connectionEventSubject.next(new ConnectionStatus(event.data.connectionStatus));
      }
    });

    this.broker.runOnService(request, null);
    clientRefreshPort.start();
  }

  public getConnectionEvents(): Observable<ConnectionStatus> {
    return this.connectionEventSubject.asObservable();
  }

  public isConnectionActive(): Promise<ConnectionStatus> {
    let request = new UiArguments("isConnectionActive");
    request.args = [];

    return new Promise<ConnectionStatus>((res) => {
      this.runOnService(request).then((data) => {
        res(new ConnectionStatus(data.connectionStatus));
      });
    });
  }

  // public sendPing():void {
  //     let request = new UiArguments('sendPing');
  //     request.args = [];
  //     this.broker.runOnService(request, null);

  protected runOnService(request: UiArguments, map: any = null): Promise<any> {
    return new Promise<any>((res, rej) => {
      this.broker.runOnService(request, PRIMITIVE).then((value: any) => {
        if (value && value.enType && value.enType == ENCODABLE_TYPE_ERRORS) {
          rej(value);
        } else {
          if (map && value) {
            if (value instanceof Array) {
              let values: Array<any> = value as Array<any>;
              values = values.map(map);
            } else {
              value = map(value);
            }
          }
          res(value);
        }
      });
    });
  }
}
